import { Injectable } from '@angular/core';
import { ApiClientService } from 'projects/dnest-core-angular/src/public-api';
import { Poll } from 'src/app/models/poll';

@Injectable({
  providedIn: 'root'
})
export class PollApiClientService extends ApiClientService<Poll> {
  endpoint = 'poll';
}

